import { createAction } from 'redux-actions';
import { actionKey } from './constants';
// Dynamic redux
export const reduxModuleLoaded = createAction(`${actionKey}.REDUX_READY`, ()=>({}));
export const createTipJarTier = createAction(`${actionKey}.CREATE_TIP_JAR_TIER`, ()=>({}));
export const deleteTier = createAction(`${actionKey}.DELETE_TIER`, (deviation, afterActionUrl)=>({
        deviation,
        afterActionUrl
    }));
export const updateTier = createAction(`${actionKey}.UPDATE_TIER`, (payload)=>payload);
export const saveTierAsDraft = createAction(`${actionKey}.SAVE_TIER_DRAFT`, (payload)=>payload);
export const saveTierAsDraftAndBuyCore = createAction(`${actionKey}.SAVE_TIER_DRAFT_AND_BUY_CORE`, (payload)=>payload);
export const publishTier = createAction(`${actionKey}.PUBLISH_TIER`, (payload)=>payload);
export const publishDraftTier = createAction(`${actionKey}.PUBLISH_DRAFT_TIER`, (deviation, afterActionUrl)=>({
        deviation,
        afterActionUrl
    }));
export const tierSaveError = createAction(`${actionKey}.TIER_SAVE_ERROR`, (message)=>({
        message
    }));
export const tierSaveRedirect = createAction(`${actionKey}.TIER_SAVE_REDIRECT`, ()=>({}));
export const tierSaveRedirectAfterDraft = createAction(`${actionKey}.TIER_SAVE_REDIRECT_AFTER_DRAFT`, ()=>({}));
export const addMediaToTier = createAction(`${actionKey}.ADD_TO_TIER`, ({ tierDeviation, deviations })=>({
        tierDeviation,
        deviations
    }));
export const requestTiers = createAction(`${actionKey}.REQUEST_TIERS`, ()=>({}));
export const requestTiersSuccess = createAction(`${actionKey}.REQUEST_TIERS_SUCCESS`, (tiers)=>({
        tiers
    }));
export const requestTiersFailure = createAction(`${actionKey}.REQUEST_TIERS_FAILURE`, (error)=>({
        error
    }));

//# sourceMappingURL=actions.js.map